<div class="uk-grid">
  <div class="uk-width-1-1 navbar">
    <p class="nav-text" *ngIf="null === internalNumber">
      Utwórz przesyłkę

      <button class="uk-button uk-button-primary padding-horizontal-small button-opt"
              [attr.uk-tooltip]="'Wróć'"
              (click)="goBackToList()"
      >
        <span uk-icon="sign-out"></span>
      </button>
    </p>
    <p class="nav-text" *ngIf="null !== shipment?.waybill">
      {{('Przesyłka ' + internalNumber)}}
      <img src="{{flagUrl()}}" style="height: 30px; margin-top: -5px" title="{{countryName()}}">
      <button class="uk-button uk-button-primary padding-horizontal-small button-opt"
              [attr.uk-tooltip]="'Wróć'"
              (click)="goBackToList()"
      >
        <span uk-icon="sign-out"></span>
      </button>

      <button class="uk-button uk-button-primary padding-horizontal-small button-opt  uk-margin-remove-right"
              [attr.uk-tooltip]="'Wymuś przypisanie do klienta'"
              (click)="openAdoptUnprocessableParcelToClientModal()"
              *ngIf="isAdoptUnprocessableParcelToClientAllowed()"
      >
        <span uk-icon="bolt"></span>
      </button>

      <button class="uk-button uk-button-primary padding-horizontal-small button-opt  uk-margin-remove-right"
              [attr.uk-tooltip]="'Wymuś przypisanie do klienta'"
              (click)="openAdoptBufferParcelToClientModal()"
              *ngIf="isAdoptBufferParcelToClientAllowed()"
      >
        <span uk-icon="bolt"></span>
      </button>

      <button class="uk-button uk-button-primary padding-horizontal-small button-opt  uk-margin-remove-right"
              [attr.uk-tooltip]="'Wygeneruj naklejkę na zwroty'"
              (click)="openReturnSticker()"
              *ngIf="isReturnStickerDownloadAllowed()"
      >
        <span uk-icon="album"></span>
      </button>


      <button class="uk-button uk-button-primary padding-horizontal-small button-opt  uk-margin-remove-right"
              [attr.uk-tooltip]="'Drukuj etykietę'"
              (click)="openDownloadLabelModal()"
              *ngIf="isDownloadLabelAllowed()"
      >
        <span uk-icon="print"></span>
      </button>

      <button
        class="uk-button uk-button-primary padding-horizontal-small button-opt uk-margin-remove-right"
        [attr.uk-tooltip]="'Nadaj nowy numer wyjściowy'"
        (click)="openSetNewBufferNumberModal()"
        *ngIf="isSetNewBufferNumberAllowed()"
      >
        <span uk-icon="table"></span>
      </button>

      <button
        *ngIf="isMarkAsRemovedAllowed()"
        class="uk-button uk-button-danger padding-horizontal-small button-opt uk-margin-remove-right"
        [attr.uk-tooltip]="'Oznacz jako usunietą'"
        (click)="openConfirmMarkAsRemovedModal()"
      >
        <span uk-icon="trash"></span>
      </button>
      <button
        *ngIf="isCopyTrackingLinkAllowed()"
        class="uk-button uk-button-primary padding-horizontal-small button-opt uk-margin-remove-right"
        [attr.uk-tooltip]="'Kopiuj link do śledzenia'"
        (click)="copyTrackingLink()"
      >
        <span uk-icon="link"></span>
      </button>
    </p>
    <p style="font-size: 15px; text-align: center; margin-top: -30px; padding-bottom: 10px"
       *ngIf="null !== shipment.internal_info.error_message"
    >
      {{shipment.internal_info.error_message}}
    </p>
  </div>
  <div class="uk-width-1-1 inner-shadow">
    <div class="uk-grid" style="margin-top: 20px !important;">
      <app-shipment-card-button
        class="uk-width-1-6 uk-padding-remove-right"
        [text]="'Dane przesyłki'"
        [cardName]="'info'"
        [activeCardName]="activeCardName"
        (buttonClicked)="activeCardChanged($event)"
      >
      </app-shipment-card-button>
      <app-shipment-card-button
        *ngIf="null !== internalNumber"
        class="uk-width-1-6 uk-padding-remove"
        [text]="'Historia'"
        [cardName]="'history'"
        [activeCardName]="activeCardName"
        (buttonClicked)="activeCardChanged($event)"
      >
      </app-shipment-card-button>
      <app-shipment-card-button
        *ngIf="UserRole.admin === userModel.role && 'shipment' === context"
        class="uk-width-1-6 uk-padding-remove"
        [text]="'Informacje wewnętrzne'"
        [cardName]="'internal_info'"
        [activeCardName]="activeCardName"
        (buttonClicked)="activeCardChanged($event)"
      >
      </app-shipment-card-button>
      <app-shipment-card-button
        *ngIf="UserRole.admin === userModel.role && 'shipment' === context"
        class="uk-width-1-6 uk-padding-remove"
        [text]="'Rozliczenie'"
        [cardName]="'finance'"
        [activeCardName]="activeCardName"
        (buttonClicked)="activeCardChanged($event)"
      >
      </app-shipment-card-button>
    </div>

    <div class="uk-card uk-card-default uk-card-body uk-margin-medium-right uk-margin-medium-top" style="margin-top: 0 !important;">
      <app-shipment-info-card
        [shipment]="shipment"
        [formDisabled]="UserRole.warehouse_worker === userModel.role"
        [isCreatingFrom]="null === internalNumber"
        [isClient]="UserRole.client === userModel.role"
        [activeParcelCardName]="activeParcelCardName"
        *ngIf="'info' === activeCardName">
      </app-shipment-info-card>

      <app-shipment-history-card
        *ngIf="'history' === activeCardName"
        [internalNumber]="internalNumber"
        [isAdmin]="UserRole.admin === userModel.role"
      >
      </app-shipment-history-card>

      <app-shipment-internal-info-card
        *ngIf="'internal_info' === activeCardName"
        [internalNumber]="internalNumber"
        [shipmentId]="shipment?.internal_info.shipment_id"
      >
      </app-shipment-internal-info-card>

      <app-shipment-finance-card
        *ngIf="UserRole.admin === userModel.role && 'finance' === activeCardName"
        [internalNumber]="internalNumber"
        [shipmentCurrency]="shipment.content.currency"
      >
      </app-shipment-finance-card>
    </div>
  </div>
</div>
<app-adopt-unprocessable-parcel-to-client-modal [parcelId]="shipment.internal_info.parcel_id"></app-adopt-unprocessable-parcel-to-client-modal>
<app-adopt-buffer-parcel-to-client-modal [parcelId]="shipment.internal_info.parcel_id"></app-adopt-buffer-parcel-to-client-modal>
<set-new-buffer-number-modal (correctlySubmittedEvent)="openByNewNumber()" [parcelId]="shipment.internal_info.parcel_id"></set-new-buffer-number-modal>
<app-download-shipment-labels-modal [internalNumber]="internalNumber"></app-download-shipment-labels-modal>
